import React from 'react';

// MUI
import InputAdornment from '@mui/material/InputAdornment';

// MUI Icons
import LockIcon from '@mui/icons-material/Lock';

function LockAdornment() {
  return (
    <InputAdornment position='end'>
      <LockIcon style={{ fontSize: 20 }} color='disabled' />
    </InputAdornment>
  );
}

export default LockAdornment;
